/* Healthybud PDP configurator — feeding mode → weight → daily amount (bag feeding guide) → purchase type → quantity → ATC */
(function () {
  'use strict';

  function fmtMoney(cents, format) {
    var f = format || '${{amount}}';
    var v = (cents / 100);
    var withDec = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec.replace('.', ','))
            .replace(/\{\{\s*amount\s*\}\}/, withDec)
            .replace(/<[^>]*>/g, '');
  }

  // 1.75 -> "1¾"
  function fmtQ(x) {
    var w = Math.floor(x + 0.01), f = Math.round((x - w) * 4);
    if (f === 4) { w += 1; f = 0; }
    var frac = ['', '¼', '½', '¾'][f];
    return (w > 0 ? String(w) : '') + frac || '0';
  }

  function Configurator(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('script[data-hb-config]').textContent);
    var c = this.cfg;
    this.state = {
      mode: c.defaultMode || 'full',
      weight: c.defaultWeight || 30,
      purchase: c.defaultPurchase || 'sub',
      weeks: c.defaultWeeks || 4,
      qty: 1,
      modeTouched: false,
      qtyTouched: false,
      autoTopper: false
    };
    this.q = function (s) { return root.querySelector(s); };
    this.qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    this.bind();
    this.render();
  }

  // Daily amount (patties/day) from the bag feeding guide, interpolated between rows.
  Configurator.prototype.daily = function (mode) {
    var c = this.cfg, g = c.guide, w = this.state.weight, d;
    if (w <= g[0][0]) d = g[0][1] * w / g[0][0];
    else if (w >= g[g.length - 1][0]) d = g[g.length - 1][1] + (c.extraPer10 || 0) * (w - g[g.length - 1][0]) / 10;
    else {
      for (var i = 0; i < g.length - 1; i++) {
        if (w >= g[i][0] && w <= g[i + 1][0]) { d = g[i][1] + (w - g[i][0]) / (g[i + 1][0] - g[i][0]) * (g[i + 1][1] - g[i][1]); break; }
      }
    }
    if (mode === 'topper') d = d * (c.topperShare || 25) / 100;
    return d;
  };

  // Days one delivery has to cover: the subscription frequency, or 4 weeks for one-time orders.
  Configurator.prototype.supplyDays = function () {
    return this.state.purchase === 'sub' ? this.state.weeks * 7 : 28;
  };

  // Whole bags needed for that period.
  Configurator.prototype.recBags = function (mode) {
    var need = this.daily(mode || this.state.mode) * this.supplyDays() / this.cfg.perBag;
    return Math.max(1, Math.ceil(need - 0.05));
  };

  Configurator.prototype.prices = function () {
    var c = this.cfg, unit = c.price;
    return {
      unit: unit,
      subFirst: Math.round(unit * (100 - c.firstOrderDiscount) / 100),
      subRecurring: Math.round(unit * (100 - c.recurringDiscount) / 100)
    };
  };

  Configurator.prototype.bind = function () {
    var self = this, s = this.state;
    var resetQty = function () { s.qtyTouched = false; var qi = self.q('[data-hb-qty-input]'); if (qi) qi.value = ''; };

    this.qa('input[name="hb-mode"]').forEach(function (el) {
      el.addEventListener('change', function () { s.mode = el.value; s.modeTouched = true; s.autoTopper = false; resetQty(); self.render(); });
    });

    var weightSel = this.q('[data-hb-weight]');
    if (weightSel) {
      weightSel.value = String(s.weight);
      weightSel.addEventListener('change', function () {
        s.weight = parseInt(weightSel.value, 10) || s.weight;
        if (!s.modeTouched) {
          var big = s.weight >= self.cfg.topperThreshold;
          s.mode = big ? 'topper' : 'full';
          s.autoTopper = big;
        }
        resetQty();
        self.render();
      });
    }

    this.qa('input[name="hb-purchase"]').forEach(function (el) {
      el.addEventListener('change', function () { s.purchase = el.value; self.render(); });
    });

    var freq = this.q('[data-hb-frequency]');
    if (freq) freq.addEventListener('change', function () { s.weeks = parseInt(freq.value, 10); self.render(); });

    // quantity: one "recommended" button + a custom-amount field beside it
    var box = this.q('[data-hb-tiles]');
    var rid = this.root.id;
    box.innerHTML =
      '<div class="hbc-pick">' +
        '<label class="hbc-tile hbc-tile--rec" for="' + rid + '-qrec">' +
          '<input type="radio" name="hb-qty-mode" id="' + rid + '-qrec" value="rec" checked>' +
          '<span class="hbc-tile__badge">For your pup</span>' +
          '<span class="hbc-tile__n" data-hb-rec-n></span><span class="hbc-tile__l" data-hb-rec-l>bags</span>' +
          '<span class="hbc-tile__sub" data-hb-rec-per></span>' +
        '</label>' +
        '<label class="hbc-tile hbc-tile--custom" for="' + rid + '-qcus">' +
          '<input type="radio" name="hb-qty-mode" id="' + rid + '-qcus" value="custom">' +
          '<span class="hbc-tile__l">Custom amount</span>' +
          '<span class="hbc-custom"><input type="number" min="1" max="60" step="1" inputmode="numeric" placeholder="#" data-hb-qty-input aria-label="Custom number of bags"><span data-hb-qty-unit>bags</span></span>' +
        '</label>' +
      '</div>';
    var qIn = box.querySelector('[data-hb-qty-input]');
    var rRec = box.querySelector('input[value="rec"]');
    var rCus = box.querySelector('input[value="custom"]');
    function applyCustom(clamp) {
      var n = parseInt(qIn.value, 10);
      if (!n || n < 1) { if (!clamp) return; n = self.recBags(); }
      n = Math.min(60, n);
      if (clamp) qIn.value = n;
      s.qtyTouched = true;
      s.qty = n;
      self.render();
    }
    function goCustom(focus) {
      if (!s.qtyTouched) { if (!qIn.value) qIn.value = self.recBags(); }
      rCus.checked = true;
      if (focus) { qIn.focus(); if (qIn.select) qIn.select(); }
      applyCustom(false);
    }
    rRec.addEventListener('change', function () { resetQty(); self.render(); });
    rCus.addEventListener('change', function () { goCustom(true); });
    qIn.addEventListener('focus', function () { if (!s.qtyTouched) goCustom(false); });
    qIn.addEventListener('input', function () { applyCustom(false); });
    qIn.addEventListener('change', function () { applyCustom(true); });
    qIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyCustom(true); qIn.blur(); } });

    var alt = this.q('[data-hb-alt]');
    if (alt) alt.addEventListener('click', function (e) {
      e.preventDefault();
      s.mode = s.mode === 'full' ? 'topper' : 'full'; s.modeTouched = true; s.autoTopper = false;
      resetQty(); self.render();
    });
    this.qa('[data-hb-switch-mode]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        s.mode = btn.getAttribute('data-hb-switch-mode'); s.modeTouched = true; s.autoTopper = false;
        resetQty(); self.render();
      });
    });

    var form = this.q('[data-hb-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); self.addToCart(); });

    var sticky = document.querySelector('[data-hb-sticky]');
    if (sticky) {
      var stickyBtn = sticky.querySelector('[data-hb-sticky-atc]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () { self.addToCart(); });
      var cta = this.q('[data-hb-atc]');
      if ('IntersectionObserver' in window && cta) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
        }).observe(cta);
      }
    }
  };

  Configurator.prototype.render = function () {
    var c = this.cfg, s = this.state, p = this.prices(), fm = c.moneyFormat;
    var set = function (sel, v) { var el = this.q(sel); if (el) el.innerHTML = v; }.bind(this);
    var unitOne = c.unitOne || 'patty', unitMany = c.unitMany || 'patties';
    var units = function (x) { return fmtQ(x) + ' ' + (x > 1.01 ? unitMany : unitOne); };

    var daily = this.daily(s.mode);
    var other = s.mode === 'full' ? 'topper' : 'full';
    var dailyOther = this.daily(other);
    // Lowest honest price: subscription $/day uses the first-order bag price shown in the Subscribe card ("from").
    var hasSub = c.plans && c.plans.length;
    var isSub = s.purchase === 'sub';
    var perUnit = (isSub ? p.subFirst : p.unit) / c.perBag;
    var lowUnit = (hasSub ? p.subFirst : p.unit) / c.perBag;
    var dayTxt = function (d, unit) { return (unit === lowUnit && hasSub ? 'from ' : '≈ ') + fmtMoney(Math.round(d * unit), fm) + '/day'; };
    var rec = this.recBags();
    if (!s.qtyTouched) s.qty = rec;
    var days = this.supplyDays();
    var period = s.purchase === 'sub' ? 'every ' + s.weeks + ' weeks' : 'for 4 weeks';

    // mode radios
    this.qa('input[name="hb-mode"]').forEach(function (el) { el.checked = el.value === s.mode; });

    // recommendation card: bags for the period + cost per day (daily amount only drives the math)
    var bagWord = function (n) { return n + (n === 1 ? ' bag' : ' bags'); };
    var recOther = this.recBags(other);
    set('[data-hb-rec-bags]', bagWord(rec));
    set('[data-hb-rec-period]', period);
    set('[data-hb-rec-perday]', dayTxt(daily, perUnit));
    set('[data-hb-rec-mode]', s.mode === 'full' ? 'as a full meal' : 'as a topper');
    set('[data-hb-rec-alt]', (other === 'topper' ? 'As a topper' : 'As a full meal') + ': ' + bagWord(recOther) + ' · ' + dayTxt(dailyOther, perUnit));
    var fullD = s.mode === 'full' ? daily : dailyOther, topD = s.mode === 'full' ? dailyOther : daily;
    try {
      window.__hbFeeding = {
        weight: s.weight, mode: s.mode, hasSub: !!hasSub,
        fullDay: fmtMoney(Math.round(fullD * lowUnit), fm), topperDay: fmtMoney(Math.round(topD * lowUnit), fm)
      };
      document.dispatchEvent(new CustomEvent('hb:feeding', { detail: window.__hbFeeding }));
    } catch (e) {}
    var altBtn = this.q('[data-hb-alt]');
    if (altBtn) altBtn.textContent = other === 'topper' ? 'Switch to topper' : 'Switch to full meal';
    var nudge = this.q('[data-hb-nudge]');
    if (nudge) nudge.hidden = !s.autoTopper;

    // purchase cards
    this.qa('input[name="hb-purchase"]').forEach(function (el) { el.checked = el.value === s.purchase; });
    set('[data-hb-sub-price]', fmtMoney(p.subFirst, fm) + '<small>/bag</small>');
    set('[data-hb-sub-compare]', fmtMoney(p.unit, fm));
    set('[data-hb-sub-then]', 'then ' + fmtMoney(p.subRecurring, fm) + '/bag on every delivery');
    set('[data-hb-otp-price]', fmtMoney(p.unit, fm) + '<small>/bag</small>');
    var freq = this.q('[data-hb-frequency]');
    if (freq) freq.value = String(s.weeks);
    var lastDays = Math.round(s.qty * c.perBag / daily);
    var lastsTxt = s.qty + (s.qty === 1 ? ' bag lasts' : ' bags last') + ' about ' + lastDays + ' days at this feeding';
    if (s.qtyTouched && lastDays < days - 3) lastsTxt += ' — you’ll run out before the next delivery.';
    else if (s.qtyTouched && lastDays > days + 10) lastsTxt += ' — more than you need between deliveries.';
    set('[data-hb-lasts]', lastsTxt + (/[.!]$/.test(lastsTxt) ? '' : '.'));
    this.root.classList.toggle('is-sub', s.purchase === 'sub');

    // quantity tiles
    set('[data-hb-rec-n]', rec);
    set('[data-hb-rec-l]', rec === 1 ? 'bag' : 'bags');
    set('[data-hb-rec-per]', s.purchase === 'sub' ? 'every ' + s.weeks + ' wks' : '4-week supply');
    var rRec = this.q('input[name="hb-qty-mode"][value="rec"]'), rCus = this.q('input[name="hb-qty-mode"][value="custom"]');
    if (rRec) rRec.checked = !s.qtyTouched;
    if (rCus) rCus.checked = !!s.qtyTouched;
    var qIn = this.q('[data-hb-qty-input]');
    if (qIn && !s.qtyTouched && document.activeElement !== qIn) qIn.value = '';
    set('[data-hb-qty-unit]', s.qtyTouched && s.qty === 1 ? 'bag' : 'bags');

    // totals + CTA
    var total = s.purchase === 'sub' ? s.qty * p.subFirst : s.qty * p.unit;
    var compare = s.qty * p.unit;
    var priceHtml = fmtMoney(total, fm) + (s.purchase === 'sub' ? ' <s>' + fmtMoney(compare, fm) + '</s>' : '');
    set('[data-hb-atc-label]', s.purchase === 'sub' ? (c.ctaSub || 'Add subscription to cart') : (c.ctaOtp || 'Add to cart'));
    set('[data-hb-atc-price]', priceHtml);

    var threshold = c.freeShippingThreshold; // same number in every market ($79 CAD / $79 USD)
    set('[data-hb-ship]', total >= threshold
      ? '<strong>Free shipping</strong> on this order'
      : 'Add ' + fmtMoney(threshold - total, fm) + ' for <strong>free shipping</strong>');

    // hidden form inputs
    var qtyInput = this.q('[data-hb-input-qty]');
    if (qtyInput) qtyInput.value = s.qty;
    var planInput = this.q('[data-hb-input-plan]');
    var planId = '';
    if (s.purchase === 'sub') {
      var plan = c.plans.filter(function (pl) { return pl.weeks === s.weeks; })[0] || c.plans[0];
      planId = plan.id;
    }
    if (planInput) { planInput.value = planId; planInput.disabled = !planId; }
    this.planId = planId;

    // sticky bar
    var sticky = document.querySelector('[data-hb-sticky]');
    if (sticky) {
      var meta = sticky.querySelector('[data-hb-sticky-meta]');
      if (meta) meta.textContent = s.qty + (s.qty === 1 ? ' bag' : ' bags') + ' · ' + (s.purchase === 'sub' ? 'Every ' + s.weeks + ' weeks' : 'One-time');
      var sl = sticky.querySelector('[data-hb-sticky-label]');
      if (sl) sl.textContent = s.purchase === 'sub' ? 'Subscribe' : 'Add to cart';
      var sp = sticky.querySelector('[data-hb-sticky-price]');
      if (sp) sp.innerHTML = priceHtml;
    }
  };

  Configurator.prototype.addToCart = function () {
    var self = this, c = this.cfg, s = this.state;
    var btns = this.qa('[data-hb-atc]').concat(Array.prototype.slice.call(document.querySelectorAll('[data-hb-sticky-atc]')));
    btns.forEach(function (b) { b.classList.add('is-loading'); b.disabled = true; });
    var item = { id: c.variantId, quantity: s.qty, properties: { _hb_feeding: s.mode, _hb_weight: String(s.weight) } };
    if (this.planId) item.selling_plan = this.planId;
    var done = function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.disabled = false; }); };

    if (c.preview) { // prototype mode
      setTimeout(function () {
        done();
        alertMsg(self, 'Prototype: would add ' + s.qty + ' × ' + c.title + (self.planId ? ' (every ' + s.weeks + ' weeks)' : ' (one-time)'));
      }, 500);
      return;
    }

    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        done();
        if (!res.ok) { alertMsg(self, res.j.description || 'Something went wrong. Please try again.'); return; }
        openCart();
      })
      .catch(function () { done(); alertMsg(self, 'Something went wrong. Please try again.'); });
  };

  function alertMsg(self, msg) {
    var t = self.q('[data-hb-toast]');
    if (t) { t.textContent = msg; t.hidden = false; setTimeout(function () { t.hidden = true; }, 4000); }
  }

  function openCart() {
    try {
      if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.fetchCart === 'function') {
        Rebuy.Cart.fetchCart(function () { if (Rebuy.SmartCart && Rebuy.SmartCart.show) Rebuy.SmartCart.show(); });
        if (Rebuy.SmartCart && Rebuy.SmartCart.show) { Rebuy.SmartCart.show(); }
        return;
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var drawer = document.querySelector('cart-drawer, #CartDrawer, [data-cart-drawer]');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    var toggle = document.querySelector('[data-cart-toggle], a[href$="/cart"].header__icon--cart, #cart-icon-bubble');
    if (toggle) { toggle.click(); return; }
    window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
  }

  // Gallery: scroll-snap track + thumbnails + dots
  function Gallery(root) {
    var track = root.querySelector('[data-hb-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hb-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hb-dot]'));
    function go(i) { var sl = slides[i]; if (sl) track.scrollTo({ left: sl.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
    function active(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      slides.forEach(function (sl, k) {
        var v = sl.querySelector('video');
        if (v) { if (k === i) { if (v.play) v.play().catch(function () {}); } else if (v.pause) v.pause(); }
      });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var prev = root.querySelector('[data-hb-prev]'), next = root.querySelector('[data-hb-next]');
    var cur = 0;
    if (prev) prev.addEventListener('click', function () { go(Math.max(0, cur - 1)); });
    if (next) next.addEventListener('click', function () { go(Math.min(slides.length - 1, cur + 1)); });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== cur) { cur = i; active(i); }
      }, 60);
    }, { passive: true });
    active(0);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-hb-configurator]').forEach(function (el) {
      if (el.__hb) return; el.__hb = new Configurator(el);
    });
    (scope || document).querySelectorAll('[data-hb-gallery]').forEach(function (el) {
      if (el.__hbg) return; el.__hbg = true; Gallery(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
